import { isStaging } from '@/modules/firebase'
import axios from 'axios'
import { getAuth } from 'firebase/auth'

export const trackInternalEvent = async (
    eventType?: string,
    documentId?: string,
    userEmail?: string,
    metadata?: Record<string, unknown>,
    timestamp?: string,
) => {
    const event = {
        eventType,
        timestamp: timestamp || new Date().toISOString(),
        // Pages get the email from App once auth resolves, so it can still be unset.
        userEmail: userEmail || getAuth().currentUser?.email,
        documentId,
        metadata,
    }

    const finalEvent = Object.fromEntries(
        Object.entries(event).filter(([_, v]) => Boolean(v)),
    )

    const endpoint = 'https://api.litta.tech/v1/internal-tracking'

    try {
        const response = await axios.post(endpoint, finalEvent, {
            params: {
                staging: isStaging.toString(),
            },
        })
        console.log('Event tracked successfully:', response.data)
    } catch (error) {
        console.error('Error tracking event:', error)
    }
}
